// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/switch/index.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {Primary} from './Primary.story';
import {Disabled} from './Disabled.story';
import {Uncontrolled} from './Uncontrolled.story';

const basic = {
  rendered: <Primary />,
  source: `<Switch
  label="This is a Switch."
  onChange={(e) => {
    console.log(e.target.checked);
  }}
/>`,
};
const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<Switch
  onChange={(e) => {
    console.log(e.target.checked);
  }}
  defaultChecked
  label="This Switch is uncontrolled."
/>`,
};
const disabled = {
  rendered: <Disabled />,
  source: `<Switch
  label="This Switch is disabled."
  defaultChecked
  disabled
/>`,
};
export const SwitchExamples = {
  basic,
  uncontrolled,
  disabled,
};
